import useStore from "config/store";
import useAccountingFirmPermissions from "hooks/Permissions/useAccountingFirmPermissions";
import useCompanyPermissions from "hooks/Permissions/useCompanyPermissions";
import useGeneralPermissions from "hooks/Permissions/useGeneralPermissions";
import { useTranslation } from "react-i18next";
import AccountingFirms from "resources/images/accounting-firms.svg?react";
import Companies from "resources/images/companies.svg?react";
import Users from "resources/images/users.svg?react";
import { ACCOUNTING_FIRM_ROUTES } from "views/AccountingFirm/utils/accountingFirmRoutes";
import { USER_ROUTES } from "views/Collaborators/utils/userRoutes";
import { COMPANY_ROUTES } from "views/Company/utils/companyRoutes";

// The SVGs carry a 24x24 viewBox and no width/height, so without this they fall
// back to the browser's default size for replaced elements.
const ICON_SIZE = 20;

export function useMenuItems() {
  const { t } = useTranslation();
  const userData = useStore(state => state.userData);

  const { canDisplayUser, canDisplayAllUsers } = useGeneralPermissions();
  const { canDisplayCompaniesList } = useCompanyPermissions();
  const { canDisplayAccountingFirms } = useAccountingFirmPermissions();

  const isClient = userData?.userCategory?.slug === "client";

  if (isClient) return [];

  const items = [
    canDisplayAccountingFirms && {
      label: t("Accounting Firms"),
      icon: <AccountingFirms width={ICON_SIZE} height={ICON_SIZE} />,
      href: ACCOUNTING_FIRM_ROUTES.accountingFirms,
    },
    canDisplayUser && {
      label: canDisplayAllUsers ? t("Users") : t("Collaborators"),
      icon: <Users width={ICON_SIZE} height={ICON_SIZE} />,
      href: USER_ROUTES.users,
    },
    canDisplayCompaniesList && {
      label: t("Companies"),
      icon: <Companies width={ICON_SIZE} height={ICON_SIZE} />,
      href: COMPANY_ROUTES.companies,
    },
  ];

  return items.filter((item): item is Exclude<typeof item, false> => Boolean(item));
}
